import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';

import RegistrationPanel from "./RegistrationPanel";
import ClientsPanel from "./ClientsPanel";
import UserPanel from "./UserPanel";
import OrderPanel from "./OrdersPanel";
import ReportPanel from "./ReportPanel";
import PricingPanel from "./PricingPanel";

function TabPanel(props) {

  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2} >
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    //height: 224,
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  tabPanel:{
    width:'100%',
  }
}));

export default function AdminInterface() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        className={classes.tabs}
      >
        <Tab label="Dashboard" {...a11yProps(0)} />
        <Tab label="Registrations" {...a11yProps(1)} />
        <Tab label="Clients" {...a11yProps(2)} />
        <Tab label="Users" {...a11yProps(3)} />
        <Tab label="Edit Orders" {...a11yProps(4)} />
        <Tab label="Reports" {...a11yProps(5)} />
        <Tab label="Pricing" {...a11yProps(6)} />
      </Tabs>
      <TabPanel className={classes.tabPanel} value={value} index={0}>
        Dashboard
      </TabPanel>
      <TabPanel className={classes.tabPanel} value={value} index={1}>
        <RegistrationPanel />  
      </TabPanel>
      <TabPanel className={classes.tabPanel} value={value} index={2}>
       <ClientsPanel />
      </TabPanel>
      <TabPanel className={classes.tabPanel} value={value} index={3}>
        <UserPanel />
      </TabPanel>
      <TabPanel className={classes.tabPanel} value={value} index={4}>
        <OrderPanel />
      </TabPanel>
      <TabPanel className={classes.tabPanel} value={value} index={5}>
        <ReportPanel />
      </TabPanel>
      <TabPanel className={classes.tabPanel} value={value} index={6}>
        <PricingPanel />
      </TabPanel>      
    </div>
  )};